module.exports = __webpack_public_path__ + "static/media/tpt.a03c44e7.png";